import { v4 as uuidv4 } from "uuid";
import { DayOfWeek } from "../domain/orchestrationCriteria.entity";

export const DEFAULT_TIMEZONE = "Europe/Madrid";

export interface WindowFormValue {
  id: string;
  startDate: string;
  endDate: string;
  activeDays: DayOfWeek[];
  startHour: Date | null;
  endHour: Date | null;
  timeZone: string;
}

export function timeStringToDate(time?: string): Date | null {
  if (!time) return null;
  const [hours, minutes] = time.split(":").map(Number);
  const d = new Date();
  d.setHours(hours, minutes, 0, 0);
  return d;
}

export function dateToTimeString(date: Date | null): string | undefined {
  if (!date) return undefined;
  const h = date.getHours().toString().padStart(2, "0");
  const m = date.getMinutes().toString().padStart(2, "0");
  return `${h}:${m}`;
}

export function emptyWindow(): WindowFormValue {
  return {
    id: uuidv4(),
    startDate: "",
    endDate: "",
    activeDays: [],
    startHour: null,
    endHour: null,
    timeZone: DEFAULT_TIMEZONE,
  };
}

export function dayStart(): Date {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

export function dayEnd(): Date {
  const d = new Date();
  d.setHours(23, 30, 0, 0);
  return d;
}

export function startHourMaxTime(endHour: Date | null): Date {
  if (!endHour) return dayEnd();
  const d = new Date(endHour);
  d.setMinutes(d.getMinutes() - 30);
  return d;
}

export function endHourMinTime(startHour: Date | null): Date {
  if (!startHour) return dayStart();
  const d = new Date(startHour);
  d.setMinutes(d.getMinutes() + 30);
  return d;
}

export function parseWindowDate(dateStr: string): Date | null {
  if (!dateStr) return null;
  const d = new Date(dateStr + "T00:00:00");
  return isNaN(d.getTime()) ? null : d;
}

export function dateToWindowDate(date: Date | null): string {
  if (!date) return "";
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}
